







































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Getter } from 'vuex-class';
import { ValidationObserver } from 'vee-validate';
import { clone } from 'lodash';
import arrayMove from 'array-move';
import { ProjectType, ProjectTypes } from '@/configs/project';
import {
  getProjectList,
  postActiveStatus,
  deleteProjectDetail,
  postProjectCreate,
  putProjectName,
  putProjectTransfer,
  putSortList,
} from '@/configs/api-path';
import VuetableMixin from '@/mixins/vuetable';
import ApiStatusMixin from '@/mixins/api-status';
import ApiErrorMixin from '@/mixins/api-error';
import DatatableHeading from '@/components/piaf/Datatable/DatatableHeading.vue';
import VuetablePaginationBootstrap from '@/components/piaf/Common/VuetablePaginationBootstrap.vue';
import { roleIsHigherThen } from '@/utils/role';
import { VuetableSortOrder, VuetablePagination } from '@/@types/vuetable.d';
import { ProjectListItem } from '@/models/project';

interface EditProjectForm {
  id: number | null;
  name: string | null;
}

const DEFAULT_EDIT_PROJECT = {
  id: null,
  name: null,
};

@Component({
  components: {
    DatatableHeading,
    VuetablePaginationBootstrap,
  },
})
export default class PageProjectList extends mixins(VuetableMixin, ApiStatusMixin, ApiErrorMixin) {
  $refs!: {
    vuetable: any;
    pagination: any;
    editProjectFormObs: InstanceType<typeof ValidationObserver>;
  };

  tablePrepage = 10;

  projectList: ProjectListItem[] = [];

  editProjectEdit = false;

  editProjectForm: EditProjectForm = DEFAULT_EDIT_PROJECT;

  get isLastestList() {
    return this.projectType === ProjectTypes.LASTEST;
  }

  get isOutdatedList() {
    return this.projectType === ProjectTypes.OUTDATED;
  }

  get isUrbanList() {
    return this.projectType === ProjectTypes.URBAN;
  }

  get isSpotlightList() {
    return this.projectType === ProjectTypes.SPOTLIGHT;
  }

  get sortPageCode() {
    let code = 0;
    switch (this.projectType) {
      case ProjectTypes.LASTEST:
        code = 4;
        break;
      case ProjectTypes.OUTDATED:
        code = 5;
        break;
      case ProjectTypes.URBAN:
        code = 6;
        break;
      case ProjectTypes.SPOTLIGHT:
        code = 2;
        break;
      default:
        break;
    }

    return code;
  }

  get pageTitle() {
    let title = '';
    switch (this.projectType) {
      case ProjectTypes.LASTEST:
        title = '新建案';
        break;
      case ProjectTypes.OUTDATED:
        title = '舊建案';
        break;
      case ProjectTypes.URBAN:
        title = '都更建案';
        break;
      case ProjectTypes.SPOTLIGHT:
        title = '熱銷建案';
        break;
      default:
        title = '建案';
        break;
    }
    return title;
  }

  get pageDescription() {
    let description = '管理建案的列表。';

    switch (this.projectType) {
      case ProjectTypes.LASTEST:
        description = '管理所有新建案的列表。';
        break;
      case ProjectTypes.OUTDATED:
        description = '管理所有舊建案的列表。';
        break;
      case ProjectTypes.URBAN:
        description = '管理金品都更的建案排序。';
        break;
      case ProjectTypes.SPOTLIGHT:
        description = '管理首頁熱銷建案排序。';
        break;
      default:
        description = '管理建案的列表。';
        break;
    }

    return description;
  }

  get statusSwitchable() {
    return !this.isSpotlightList && !this.isUrbanList && this.testRoleIsHigher(3);
  }

  get actionFieldWidth() {
    // eslint-disable-next-line no-nested-ternary
    return !this.isLastestList
      // eslint-disable-next-line no-nested-ternary
      ? this.isSpotlightList || this.isUrbanList
        ? '200px'
        : this.sortMode
          ? '200px'
          : '300px'
      : this.sortMode
        ? '200px'
        : '410px';
  }

  get dataTableFields() {
    return [
      {
        name: 'thumbnail--slot',
        title: '縮圖',
        titleClass: 'px-2 text-center',
        dataClass: 'custom-img p-0 position-relative',
        width: '60px',
      },
      {
        name: 'name',
        title: '建案名稱',
        sortField: this.sortMode ? null : 'name',
      },
      {
        name: 'updated_at',
        title: '更新日期',
        sortField: this.sortMode ? null : 'updated_at',
        width: '130px',
      },
      // {
      //   name: 'sort',
      //   title: '排序',
      //   width: '78px',
      //   sortField: this.sortMode ? null : 'sort',
      //   titleClass: 'text-center',
      //   dataClass: 'text-center',
      // },
      {
        name: 'status--slot',
        title: '建案狀態',
        width: '110px',
        titleClass: 'text-center',
        dataClass: 'text-center',
      },
      {
        name: 'action--slot',
        title: '操作',
        width: this.actionFieldWidth,
        titleClass: 'text-center',
        dataClass: 'text-center pl-2',
      },
    ];
  }

  get filterKeyword() {
    // Convert wildcard search. (?|*)
    return this.searchKeywords.replace(/(\?|\*)/g, '\\w');
  }

  // TODO: search fields
  get filtedProjectList() {
    return this.projectList.filter((project) => {
      const matchRegexp = new RegExp(
        this.filterKeyword === '' ? '.*' : `.*(${this.filterKeyword}).*`,
        'gi',
      );

      const matchName = project.name.match(matchRegexp);

      return Boolean(matchName);
    });
  }

  get projectType(): ProjectType {
    return this.$route.params.projectType as ProjectType;
  }

  get isEditProjectEditMode() {
    return this.editProjectForm.id !== null;
  }

  get canSort() {
    return this.projectList.length > 1;
  }

  get breadcrumb() {
    const prefixBread = this.isSpotlightList ? [
      {
        text: '首頁管理',
        to: null,
      },
    ] : [
      {
        text: '建案管理',
        to: null,
      },
    ];

    const suffixBread = (this.isUrbanList || this.isSpotlightList) ? [
      // {
      //   text: '建案列表',
      //   to: null,
      // },
    ] : [];

    return [
      ...prefixBread,
      {
        text: this.pageTitle,
        to: null,
      },
      ...suffixBread,
    ];
  }

  @Getter('user/currentUser') currentUser!: {
    id: number;
    name: string;
    role: {
      code: number;
      text: string;
    };
  };

  @Watch('filtedProjectList')
  onFiltedProjectListChange() {
    this.$refs.vuetable.refresh();
  }

  @Watch('tablePrepage')
  onTablePrepageChange() {
    if (this.vuetablePrepage !== undefined) {
      this.vuetablePrepage = this.tablePrepage;
    }
    this.$refs.vuetable.refresh();
  }

  @Watch('sortMode')
  onSortModeChange(newValue: boolean) {
    this.$refs.vuetable.refresh();

    if (newValue === false) {
      this.fetchProjectList();
    }
  }

  getIndexInRealList(projectId: number) {
    const sortedProjectList = this.projectList;

    const indexInList = sortedProjectList.findIndex((project) => project.id === projectId);

    return {
      isFirst: indexInList === 0,
      isLast: indexInList === sortedProjectList.length - 1,
      index: indexInList,
    };
  }

  // TODO: Confirm function
  testRoleIsHigher(roleCode: number) {
    return roleIsHigherThen(this.currentUser.role.code, roleCode, true);
  }

  editProjectName(project: ProjectListItem) {
    this.editProjectForm.id = project.id;
    this.editProjectForm.name = project.name;
  }

  resetEditProjectForm() {
    this.editProjectForm.id = null;
    this.editProjectForm.name = null;
    this.$refs.editProjectFormObs.reset();
  }

  toggleSortMode() {
    this.sortMode = !this.sortMode;
  }

  async sortProject(itemId: number, direction: 1 | -1) {
    const currentPosition = this.getIndexInRealList(itemId);
    // check sort request is avaliable
    if (
      (currentPosition.isFirst === true && direction === -1)
      || (currentPosition.isLast === true && direction === 1)
    ) {
      console.warn('You cannot do this action.');
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sotrList = (list: any[], fromId: number, mutate = false) => {
      const currentList = list;
      const targetIndex = currentList.findIndex((item) => item.id === fromId);
      const nextIndex = targetIndex + direction;

      if (mutate === true) {
        arrayMove.mutate(currentList, targetIndex, nextIndex);
      }

      return arrayMove(clone(currentList), targetIndex, nextIndex);
    };

    try {
      const newOrderIds: number[] = sotrList(this.projectList, itemId)
        .map((item) => item.id);

      this.setApiLoading();
      const { data: sortItemResponse } = await this.$axios.put<{
        code: number;
      }>(putSortList, {
        page: this.sortPageCode,
        object_ids: newOrderIds,
      });
      this.setApiPending();

      if (sortItemResponse.code === 0) {
        this.fetchProjectList();
        return;
      }

      this.apiErrorCodeAlert(sortItemResponse.code, `${this.pageTitle}排序`);
    } catch (error) {
      console.error(error);
      this.setApiPending();
      this.$notify.show('error filled', '儲存建案排序時發生錯誤。', '建案排序', {
        duration: 3000,
        permanent: false,
      });
    }
  }

  onHideCreateProjectModal() {
    this.resetEditProjectForm();
  }

  hideModal(refname: string) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const vmRefs = this.$refs as any;

    if (!vmRefs[refname]) {
      return;
    }

    vmRefs[refname].hide();
    console.log(`hide modal:: ${refname}`);

    if (refname === 'modalnestedinline') {
      vmRefs.modalnested.show();
    }
  }

  changePageSize(size: number) {
    this.tablePrepage = size;
  }

  onPaginationData(paginationData: VuetablePagination) {
    this.$refs.pagination.setPaginationData(paginationData);
  }

  onChangePage(page: number) {
    this.$refs.vuetable.changePage(page);
  }

  dataManager(sortOrder: VuetableSortOrder[], pagination: VuetablePagination) {
    const tableData = this.vuetableDataManager(
      this.sortMode ? [] : sortOrder,
      pagination,
      this.$refs.vuetable,
      this.sortMode ? this.projectList : this.filtedProjectList,
    );
    this.tablePagination = tableData.pagination;
    return tableData;
  }

  async editProjectSubmit(modalName: string) {
    try {
      const validateResult = await this.$refs.editProjectFormObs.validate();

      if (validateResult === false) {
        return;
      }

      if (this.editProjectForm.id === null) {
        this.createProjectHandler(modalName);
      } else {
        this.updateProjectNameHandler(modalName);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async createProjectHandler(modalName: string) {
    this.setApiLoading();

    const projectName = this.editProjectForm.name;
    try {
      const { data: createProjectResponse } = await this.$axios.post<{
        code: number;
        project: {
          id: number;
        };
      }>(postProjectCreate, {
        name: this.editProjectForm.name,
      });

      this.setApiPending();
      if (createProjectResponse.code === 0) {
        this.$store.dispatch('app/fetchMenuProjects', this);
        this.$notify.show('success filled', `${projectName}已建立！`, '建立建案', {
          duration: 3000,
          permanent: false,
        });

        this.resetEditProjectForm();
        this.hideModal(modalName);

        this.fetchProjectList();
      } else {
        this.apiErrorCodeAlert(createProjectResponse.code, '建立建案', {
          103: '建案名稱已存在',
        });
      }
    } catch (error) {
      console.error(error);
      this.setApiPending();
    }
  }

  async updateProjectNameHandler(modalName: string) {
    const projectId = this.editProjectForm.id as number;
    const projectName = this.editProjectForm.name;
    const originalProject = this.projectList.find((project) => project.id === projectId);
    if (!originalProject) {
      return;
    }
    this.setApiLoading();
    try {
      const { data: updateProjectResponse } = await this.$axios.put<{
        code: number;
        project: {
          id: number;
        };
      }>(putProjectName(projectId), {
        name: this.editProjectForm.name,
      });

      this.setApiPending();
      if (updateProjectResponse.code === 0) {
        this.$store.dispatch('app/fetchMenuProjects', this);
        this.$notify.show('success filled', `${originalProject.name}已更新為${projectName}！`, '編輯建案', {
          duration: 3000,
          permanent: false,
        });

        this.resetEditProjectForm();
        this.hideModal(modalName);

        this.fetchProjectList();
      } else {
        this.apiErrorCodeAlert(updateProjectResponse.code, '編輯建案', {
          103: '建案名稱已存在',
        });
      }
    } catch (error) {
      console.error(error);
      this.setApiPending();
    }
  }

  async fetchProjectList() {
    this.setApiLoading();
    try {
      const { data: projectListResponse } = await this.$axios.get<{
        code: number;
        project: ProjectListItem[];
      }>(getProjectList(this.projectType));

      if (projectListResponse.code === 0) {
        this.projectList = projectListResponse.project;
      } else {
        this.apiErrorCodeAlert(projectListResponse.code as number);
        // console.error(projectListResponse.code);
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  async toggleProjectStatus(nextStatus: boolean, project: ProjectListItem) {
    if (!project.id) {
      return;
    }

    this.setApiLoading();
    try {
      const statusData = {
        module: 6,
        targetId: project.id,
        status: nextStatus,
      };

      const { data: projectStatusResponse } = await this.$axios.post<{
        code: number;
      }>(postActiveStatus, statusData);

      if (projectStatusResponse.code === 0) {
        this.$notify.show(
          'success filled',
          `${project.name}已${nextStatus === true ? '啟用' : '停用'}！`,
          `${nextStatus === true ? '啟用' : '停用'}建案`,
          { duration: 3000, permanent: false },
        );
        this.$store.dispatch('app/fetchMenuProjects', this);
      } else {
        // fallback status
        const projectInList = this.projectList.find((oProject) => oProject.id === project.id);
        if (projectInList) {
          projectInList.status = !nextStatus;
        }
        this.apiErrorCodeAlert(
          projectStatusResponse.code,
          `${nextStatus === true ? '啟用' : '停用'}建案`, {
            108: '此建案已有住戶及招待人員，不可改為停用。',
            109: '啟用建案失敗，建案內容未填寫完整。',
          },
        );
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  async transferProject(project: ProjectListItem) {
    const projectId = project.id;
    const confirm = window.confirm(`確定將 ${project.name} 移轉至舊建案？\n移轉後將無法復原回新建案。`);

    if (confirm === false) {
      return;
    }

    this.setApiLoading();
    try {
      const { data: projectTransferResponse } = await this.$axios.put<{
        code: number;
        project: {
          id: number;
        };
      }>(putProjectTransfer(projectId));

      if (projectTransferResponse.code === 0) {
        this.$notify.show('success filled', `${project.name}已成功轉入舊建案！`, '建案移轉', {
          duration: 3000,
          permanent: false,
        });
        const projectIndexInList = this.projectList
          .findIndex((oProject) => oProject.id === projectId);

        this.projectList.splice(projectIndexInList, 1);
      } else {
        this.apiErrorCodeAlert(projectTransferResponse.code, '建案移轉');
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  async deleteProject(project: ProjectListItem) {
    const projectId = project.id;
    const confirm = window.confirm(`確定刪除 ${project.name} ？\n刪除後將無法復原該建案相關資料。`);

    if (confirm === false) {
      return;
    }

    this.setApiLoading();
    try {
      const { data: projectDeleteResponse } = await this.$axios.delete<{
        code: number;
        project: {
          id: number;
        };
      }>(deleteProjectDetail(projectId));

      if (projectDeleteResponse.code === 0) {
        this.$notify.show('success filled', `${project.name}已刪除！`, '刪除建案', {
          duration: 3000,
          permanent: false,
        });
        const projectIndexInList = this.projectList
          .findIndex((oProject) => oProject.id === projectId);

        this.projectList.splice(projectIndexInList, 1);
      } else {
        this.apiErrorCodeAlert(projectDeleteResponse.code, '刪除建案', {
          107: '刪除失敗，該建案已有招待人員或住戶，不可刪除',
        });
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  beforeMount() {
    this.fetchProjectList();
  }
}
